import { clearSession, getToken } from './auth';

function handleErrors(res) {
  // On auth failure just drop the stale session. Do NOT reload here — when
  // logged out every protected endpoint returns 401, and reloading would
  // create an infinite refresh loop. The UI shows the logged-out state on
  // its own (isLogin=false) and the user can click 登入.
  if (res.status === 401 || res.status === 403) {
    clearSession();
  }
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res;
}

export const callApi = (url = '', options = {}) => {
  const token = getToken();
  const headers = {
    'content-type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  return fetch(url, {
    credentials: 'include',
    ...options,
    headers,
  })
    .then(handleErrors)
    .then((response) => response.json())
    .catch((error) => {
      console.log(error);
      return null;
    });
};

export default callApi;
